import handleEventName from './event-name-handler';

/**
 * Функция-подписчик
 */
function subscribe(evt, callback) {
  const self = this;
  const eventsArr = handleEventName(evt);

  eventsArr.forEach(evtName => {
    try {
      self._selectEvent(evtName).add(callback);
    } catch (err) {
      console.warn(err);
    } finally {
      return;
    }
  });

  return;
}

export default subscribe;
